var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      attrs: {
        title: "抽样项目详情",
        okText: "确定",
        cancelText: "取消",
        width: "1200px",
        visible: _vm.visible,
        "confirm-loading": _vm.confirmLoading,
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-form-model",
        {
          ref: "ruleForm",
          attrs: {
            model: _vm.formState,
            rules: _vm.rules,
            "label-col": { span: 8 },
            "wrapper-col": { span: 16 },
          },
        },
        [
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "项目名称",
                        prop: "prjName",
                      },
                    },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.prjName,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "prjName", $$v)
                          },
                          expression: "formState.prjName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "牵头单位", prop: "leaderName" } },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.leaderName,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "leaderName", $$v)
                          },
                          expression: "formState.leaderName",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "监测品类", prop: "hangye" } },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.hangye,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "hangye", $$v)
                          },
                          expression: "formState.hangye",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "项目开始时间", prop: "startDate" } },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.startDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "startDate", $$v)
                          },
                          expression: "formState.startDate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-col",
                { attrs: { span: "12" } },
                [
                  _c(
                    "a-form-model-item",
                    { attrs: { label: "项目结束时间", prop: "endDate" } },
                    [
                      _c("a-input", {
                        model: {
                          value: _vm.formState.endDate,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "endDate", $$v)
                          },
                          expression: "formState.endDate",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 4 },
                        wrapperCol: { span: 20 },
                        label: "监测环节",
                        prop: "monitLink",
                      },
                    },
                    [
                      _c("a-ext-monit-link-check-group", {
                        model: {
                          value: _vm.formState.monitLink,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "monitLink", $$v)
                          },
                          expression: "formState.monitLink",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 0 },
                        wrapperCol: { span: 24 },
                        prop: "monitTaskRegion",
                      },
                    },
                    [
                      _c("a-ext-check-target-picker-province", {
                        model: {
                          value: _vm.formState.monitTaskRegion,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "monitTaskRegion", $$v)
                          },
                          expression: "formState.monitTaskRegion",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "a-form-model-item",
                    {
                      attrs: {
                        labelCol: { span: 0 },
                        wrapperCol: { span: 24 },
                        prop: "monitProduce",
                      },
                    },
                    [
                      _c("a-ext-pin-zhong-and-bad-select", {
                        model: {
                          value: _vm.formState.monitProduce,
                          callback: function ($$v) {
                            _vm.$set(_vm.formState, "monitProduce", $$v)
                          },
                          expression: "formState.monitProduce",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }